// FLE level test — 40 questions, 8 per level (A1 → C1).
// Each test attempt randomly selects 4 questions per level (20 total per attempt).
export const QUIZ_QUESTIONS = [
  // ===== A1 =====
  {
    id: 1,
    level: "A1",
    question: "Bonjour, je ___ Lucas, et toi ?",
    options: ["es", "suis", "est", "sommes"],
    correctIndex: 1,
    explanation: "Verbe « être » au présent, 1ʳᵉ personne du singulier : « je suis ».",
  },
  {
    id: 2,
    level: "A1",
    question: "___ table est très grande.",
    options: ["Le", "La", "Les", "Un"],
    correctIndex: 1,
    explanation: "« Table » est un nom féminin singulier → article défini « la ».",
  },
  {
    id: 3,
    level: "A1",
    question: "Tu ___ le français à l'école ?",
    options: ["parle", "parles", "parlons", "parlent"],
    correctIndex: 1,
    explanation: "Verbe « parler » au présent, 2ᵉ personne du singulier : « tu parles ».",
  },
  {
    id: 4,
    level: "A1",
    question: "J'ai 25 ___.",
    options: ["jours", "heures", "ans", "mois"],
    correctIndex: 2,
    explanation: "Pour exprimer l'âge en français, on utilise « avoir + ans ».",
  },
  {
    id: 5,
    level: "A1",
    question: "Comment ___-tu aujourd'hui ?",
    options: ["es", "vas", "fais", "sors"],
    correctIndex: 1,
    explanation: "« Comment vas-tu ? » est la formule classique pour demander comment quelqu'un se sent.",
  },
  {
    id: 6,
    level: "A1",
    question: "Il y a ___ chats dans le jardin.",
    options: ["un", "une", "des", "du"],
    correctIndex: 2,
    explanation: "Article indéfini pluriel : « des chats ».",
  },
  {
    id: 7,
    level: "A1",
    question: "Quelle heure est-il ? Il est ___ heures.",
    options: ["huit", "huite", "huites", "de huit"],
    correctIndex: 0,
    explanation: "Les nombres cardinaux sont invariables. On écrit « huit heures ».",
  },
  {
    id: 8,
    level: "A1",
    question: "Qu'est-ce que tu fais ? Je ___ la télé.",
    options: ["regarde", "regardes", "regarder", "regarderai"],
    correctIndex: 0,
    explanation: "1ʳᵉ personne du singulier au présent : « je regarde ».",
  },

  // ===== A2 =====
  {
    id: 9,
    level: "A2",
    question: "Hier, je ___ au cinéma avec mes amis.",
    options: ["suis allé", "ai allé", "vais", "allais"],
    correctIndex: 0,
    explanation: "Passé composé du verbe « aller » : auxiliaire « être » → « je suis allé ».",
  },
  {
    id: 10,
    level: "A2",
    question: "Quand j'étais petit, je ___ au foot tous les jours.",
    options: ["joue", "jouais", "ai joué", "jouerai"],
    correctIndex: 1,
    explanation: "Habitude dans le passé → imparfait : « je jouais ».",
  },
  {
    id: 11,
    level: "A2",
    question: "Je n'ai pas ___ vélo.",
    options: ["un", "le", "de", "des"],
    correctIndex: 2,
    explanation: "À la forme négative, « un / une / des » deviennent « de ».",
  },
  {
    id: 12,
    level: "A2",
    question: "Je vois Marie souvent. Je ___ vois tous les jours.",
    options: ["le", "la", "lui", "les"],
    correctIndex: 1,
    explanation: "« Marie » est COD féminin singulier → pronom « la ».",
  },
  {
    id: 13,
    level: "A2",
    question: "Nous ___ partis tôt ce matin.",
    options: ["avons", "sommes", "étions", "aurons"],
    correctIndex: 1,
    explanation: "Verbe « partir » au passé composé se conjugue avec « être » : « nous sommes partis ».",
  },
  {
    id: 14,
    level: "A2",
    question: "Mon frère est plus grand ___ moi.",
    options: ["que", "de", "comme", "à"],
    correctIndex: 0,
    explanation: "Comparatif de supériorité avec un adjectif : « plus … que ».",
  },
  {
    id: 15,
    level: "A2",
    question: "Je vais ___ Paris en train.",
    options: ["à", "au", "en", "dans"],
    correctIndex: 0,
    explanation: "Devant un nom de ville, on utilise « à » : « à Paris ».",
  },
  {
    id: 16,
    level: "A2",
    question: "Tu connais ce film ? Oui, je l'ai ___ trois fois.",
    options: ["vu", "vue", "voir", "vois"],
    correctIndex: 0,
    explanation: "Le COD « l' » (= le film, masculin) est placé avant le verbe → accord : « vu ».",
  },

  // ===== B1 =====
  {
    id: 17,
    level: "B1",
    question: "Il faut que tu ___ à l'heure demain.",
    options: ["viens", "viennes", "venir", "venais"],
    correctIndex: 1,
    explanation: "« Il faut que » + subjonctif → « que tu viennes ».",
  },
  {
    id: 18,
    level: "B1",
    question: "Demain, je ___ à Paris pour le week-end.",
    options: ["vais", "irai", "aller", "allais"],
    correctIndex: 1,
    explanation: "Futur simple du verbe « aller » : « j'irai ».",
  },
  {
    id: 19,
    level: "B1",
    question: "C'est le livre ___ j'ai lu hier soir.",
    options: ["qui", "que", "dont", "où"],
    correctIndex: 1,
    explanation: "« Le livre » est COD du verbe « lire » → pronom relatif « que ».",
  },
  {
    id: 20,
    level: "B1",
    question: "Si j'avais le temps, je ___ en Asie.",
    options: ["voyageais", "voyagerais", "voyage", "voyagerai"],
    correctIndex: 1,
    explanation: "« Si » + imparfait → conditionnel présent : « je voyagerais ».",
  },
  {
    id: 21,
    level: "B1",
    question: "Bien qu'il ___ malade, il est venu travailler.",
    options: ["est", "soit", "était", "sera"],
    correctIndex: 1,
    explanation: "« Bien que » est toujours suivi du subjonctif : « qu'il soit ».",
  },
  {
    id: 22,
    level: "B1",
    question: "Il m'a dit qu'il ___ le lendemain.",
    options: ["vient", "venait", "viendrait", "viendra"],
    correctIndex: 2,
    explanation: "Futur dans le passé → conditionnel présent : « il viendrait ».",
  },
  {
    id: 23,
    level: "B1",
    question: "Plus on travaille, ___ on progresse.",
    options: ["plus", "moins", "mieux", "davantage"],
    correctIndex: 0,
    explanation: "Structure corrélative : « plus … plus … ».",
  },
  {
    id: 24,
    level: "B1",
    question: "Je ne sais pas ___ tu parles.",
    options: ["que", "dont", "de qui", "qui"],
    correctIndex: 2,
    explanation: "« Parler de quelqu'un » → l'interrogation indirecte garde « de qui ».",
  },

  // ===== B2 =====
  {
    id: 25,
    level: "B2",
    question: "Quand je suis arrivé, le film ___ déjà commencé.",
    options: ["a", "avait", "aurait", "avais"],
    correctIndex: 1,
    explanation: "Antériorité dans le passé → plus-que-parfait : « avait commencé ».",
  },
  {
    id: 26,
    level: "B2",
    question: "Je suis content que tu ___ venu hier soir.",
    options: ["es", "sois", "étais", "seras"],
    correctIndex: 1,
    explanation: "Expression de sentiment + « que » → subjonctif : « que tu sois venu ».",
  },
  {
    id: 27,
    level: "B2",
    question: "Il est arrivé en retard ___ une grève de transports.",
    options: ["parce que", "à cause de", "grâce à", "malgré"],
    correctIndex: 1,
    explanation: "« À cause de » introduit une cause négative + nom. « Parce que » serait suivi d'une proposition.",
  },
  {
    id: 28,
    level: "B2",
    question: "Elle a réussi son examen haut ___",
    options: ["le bras", "la main", "le pied", "la voix"],
    correctIndex: 1,
    explanation: "Expression idiomatique : « haut la main » = facilement, sans difficulté.",
  },
  {
    id: 29,
    level: "B2",
    question: "Le rapport ___ je vous parle est sur le bureau.",
    options: ["que", "dont", "duquel", "lequel"],
    correctIndex: 1,
    explanation: "« Parler de » → pronom relatif « dont » remplace « de + nom ».",
  },
  {
    id: 30,
    level: "B2",
    question: "Pourvu qu'il ___ beau demain !",
    options: ["fait", "fasse", "fera", "faisait"],
    correctIndex: 1,
    explanation: "« Pourvu que » exprime un souhait → subjonctif : « qu'il fasse ».",
  },
  {
    id: 31,
    level: "B2",
    question: "Il s'est fait ___ par son patron pour son retard.",
    options: ["réprimander", "réprimandé", "réprimandée", "réprimandant"],
    correctIndex: 0,
    explanation: "« Se faire » + infinitif (sens passif) → « se faire réprimander ».",
  },
  {
    id: 32,
    level: "B2",
    question: "Il a beau ___, personne ne l'écoute.",
    options: ["crier", "criant", "crié", "avoir crié"],
    correctIndex: 0,
    explanation: "« Avoir beau » + infinitif présent → « il a beau crier ».",
  },

  // ===== C1 =====
  {
    id: 33,
    level: "C1",
    question: "« Il aurait fallu qu'il ___ plus tôt. » (registre soutenu)",
    options: ["vienne", "vînt", "venait", "viendrait"],
    correctIndex: 1,
    explanation: "Concordance des temps soutenue : subjonctif imparfait « vînt » après un conditionnel passé.",
  },
  {
    id: 34,
    level: "C1",
    question: "___ il fasse, rien ne semble lui réussir.",
    options: ["Quoi que", "Quoique", "Bien qu'", "Malgré qu'"],
    correctIndex: 0,
    explanation: "« Quoi que » (en deux mots) = quelle que soit la chose que. « Quoique » (en un mot) = bien que.",
  },
  {
    id: 35,
    level: "C1",
    question: "« Couper l'herbe sous le ___ de quelqu'un » signifie devancer.",
    options: ["sol", "pied", "dos", "nez"],
    correctIndex: 1,
    explanation: "Expression imagée : « couper l'herbe sous le pied » = priver quelqu'un d'un avantage en agissant avant lui.",
  },
  {
    id: 36,
    level: "C1",
    question: "« On ne saurait trop insister sur ce point. » Ce registre est :",
    options: ["familier", "courant", "soutenu", "argotique"],
    correctIndex: 2,
    explanation: "Tournure impersonnelle avec « savoir » au conditionnel → registre soutenu.",
  },
  {
    id: 37,
    level: "C1",
    question: "Si j'avais su, je ne ___ pas venu.",
    options: ["sois", "serais", "suis", "étais"],
    correctIndex: 1,
    explanation: "« Si » + plus-que-parfait → conditionnel passé : « je ne serais pas venu ».",
  },
  {
    id: 38,
    level: "C1",
    question: "On l'a accusé ___ ce qu'il n'avait pas commis.",
    options: ["de", "pour", "par", "sur"],
    correctIndex: 0,
    explanation: "« Accuser quelqu'un de quelque chose » → préposition « de ».",
  },
  {
    id: 39,
    level: "C1",
    question: "Mettre la charrue avant les ___",
    options: ["chevaux", "bœufs", "ânes", "vaches"],
    correctIndex: 1,
    explanation: "Expression idiomatique : « mettre la charrue avant les bœufs » = faire les choses dans le mauvais ordre.",
  },
  {
    id: 40,
    level: "C1",
    question: "« Force est de constater qu'il a raison. » Cette tournure est :",
    options: ["familière", "standard", "soutenue", "vulgaire"],
    correctIndex: 2,
    explanation: "« Force est de » + infinitif est une formule impersonnelle élégante, propre au registre soutenu.",
  },

  // ===== Bonus questions (added later) =====
  // --- A1 ---
  {
    id: 41,
    level: "A1",
    question: "C'est Marie. ___ est française.",
    options: ["Il", "Elle", "Ils", "Elles"],
    correctIndex: 1,
    explanation: "« Marie » est un prénom féminin singulier → pronom sujet « Elle ».",
  },
  {
    id: 42,
    level: "A1",
    question: "Le livre est ___ la table.",
    options: ["dans", "sur", "avec", "pour"],
    correctIndex: 1,
    explanation: "Pour indiquer qu'un objet est posé au-dessus, on utilise la préposition « sur ».",
  },
  {
    id: 43,
    level: "A1",
    question: "Mes parents ___ deux enfants.",
    options: ["a", "as", "avons", "ont"],
    correctIndex: 3,
    explanation: "Verbe « avoir » au présent, 3ᵉ personne du pluriel : « ils / elles ont ».",
  },
  // --- A2 ---
  {
    id: 44,
    level: "A2",
    question: "Je voudrais ___ baguette, s'il vous plaît.",
    options: ["un", "une", "des", "de la"],
    correctIndex: 1,
    explanation: "« Baguette » est un nom féminin singulier → article indéfini « une ».",
  },
  {
    id: 45,
    level: "A2",
    question: "C'est ___ sœur, elle s'appelle Camille.",
    options: ["mon", "ma", "mes", "ton"],
    correctIndex: 1,
    explanation: "Adjectif possessif féminin singulier (parlant de moi) : « ma sœur ».",
  },
  {
    id: 46,
    level: "A2",
    question: "Nous ___ le cours à 9 heures.",
    options: ["finit", "finissons", "finissez", "finissent"],
    correctIndex: 1,
    explanation: "Verbe « finir » (2ᵉ groupe) au présent, 1ʳᵉ personne du pluriel : « nous finissons ».",
  },
  // --- B1 ---
  {
    id: 47,
    level: "B1",
    question: "Je pense qu'il ___ raison.",
    options: ["a", "ait", "avait", "aurait"],
    correctIndex: 0,
    explanation: "« Penser que » à la forme affirmative est suivi de l'indicatif : « qu'il a raison ».",
  },
  {
    id: 48,
    level: "B1",
    question: "Il s'est blessé en ___",
    options: ["courant", "courrant", "courir", "courait"],
    correctIndex: 0,
    explanation: "Gérondif (« en » + participe présent) → « en courant ». Attention : un seul « r ».",
  },
  {
    id: 49,
    level: "B1",
    question: "Tu vas à Paris ? Oui, j'___ vais demain.",
    options: ["en", "y", "le", "là"],
    correctIndex: 1,
    explanation: "Le pronom « y » remplace un complément de lieu introduit par « à » : « j'y vais ».",
  },
  // --- B2 ---
  {
    id: 50,
    level: "B2",
    question: "Il a dit : « Je suis fatigué. » → Il a dit qu'il ___ fatigué.",
    options: ["est", "était", "sera", "soit"],
    correctIndex: 1,
    explanation: "Discours indirect au passé : le présent du discours direct devient imparfait.",
  },
  {
    id: 51,
    level: "B2",
    question: "Il continue à courir ___ sa fatigue.",
    options: ["à cause de", "malgré", "grâce à", "parce que"],
    correctIndex: 1,
    explanation: "« Malgré » + nom exprime la concession (opposition).",
  },
  {
    id: 52,
    level: "B2",
    question: "C'est le meilleur livre que j'___ jamais lu.",
    options: ["ai", "aie", "avais", "aurais"],
    correctIndex: 1,
    explanation: "Après un superlatif (« le meilleur »), on emploie le subjonctif : « que j'aie lu ».",
  },
  // --- C1 ---
  {
    id: 53,
    level: "C1",
    question: "Peut-être ___ raison après tout. (inversion soutenue)",
    options: ["il a", "a-t-il", "qu'il a", "il aurait"],
    correctIndex: 1,
    explanation: "Après « peut-être » en tête de phrase, l'inversion sujet-verbe est de rigueur en registre soutenu : « peut-être a-t-il ».",
  },
  {
    id: 54,
    level: "C1",
    question: "Il s'en est fallu de ___ que je rate mon train.",
    options: ["peu", "peux", "petit", "pou"],
    correctIndex: 0,
    explanation: "Expression figée : « il s'en est fallu de peu » = il a presque manqué quelque chose.",
  },
  {
    id: 55,
    level: "C1",
    question: "« Il n'est pas dit qu'il ___ ce poste. » (incertitude soutenue)",
    options: ["obtient", "obtiendra", "obtienne", "aurait obtenu"],
    correctIndex: 2,
    explanation: "« Il n'est pas dit que » exprime un doute → subjonctif : « qu'il obtienne ».",
  },
];

// Pick N random questions per CEFR level (Fisher–Yates shuffle).
export const buildQuizSet = (perLevel = 4) => {
  const levels = ["A1", "A2", "B1", "B2", "C1"];
  return levels.flatMap((level) => {
    const pool = QUIZ_QUESTIONS.filter((q) => q.level === level);
    const arr = [...pool];
    for (let i = arr.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr.slice(0, perLevel);
  });
};

// Score → CEFR level (score out of `total` questions, where the questions
// are evenly distributed across 5 levels).
export const levelFromScore = (score, total) => {
  const ratio = total > 0 ? score / total : 0;
  if (ratio <= 0.2) return "A1";
  if (ratio <= 0.4) return "A2";
  if (ratio <= 0.6) return "B1";
  if (ratio <= 0.8) return "B2";
  return "C1";
};

export const LEVEL_DESCRIPTIONS = {
  A1: {
    pt: "Iniciante. Você reconhece frases simples e do dia a dia. Próximo passo: construir vocabulário básico e conjugações no presente.",
    en: "Beginner. You recognise everyday simple sentences. Next step: build core vocabulary and present-tense verbs.",
    fr: "Débutant. Vous reconnaissez des phrases simples du quotidien. Étape suivante : enrichir le vocabulaire de base et le présent.",
  },
  A2: {
    pt: "Básico. Você se vira em situações cotidianas. Próximo passo: passado composto, imperfeito e pronomes complementos.",
    en: "Elementary. You cope with everyday situations. Next step: passé composé, imperfect and object pronouns.",
    fr: "Élémentaire. Vous gérez le quotidien. Étape suivante : passé composé, imparfait et pronoms compléments.",
  },
  B1: {
    pt: "Intermediário. Você fala em viagens e sobre temas conhecidos. Próximo passo: subjuntivo, condicional e pronomes relativos.",
    en: "Intermediate. You handle travel and familiar topics. Next step: subjunctive, conditional and relative pronouns.",
    fr: "Intermédiaire. Vous discutez en voyage et de sujets familiers. Étape suivante : subjonctif, conditionnel et relatifs.",
  },
  B2: {
    pt: "Avançado. Você argumenta com fluência. Próximo passo: plus-que-parfait, subjuntivo passado e nuances de causa/consequência.",
    en: "Upper-intermediate. You argue fluently. Next step: plus-que-parfait, past subjunctive and cause/consequence nuances.",
    fr: "Avancé. Vous argumentez avec aisance. Étape suivante : plus-que-parfait, subjonctif passé et nuances cause/conséquence.",
  },
  C1: {
    pt: "Autônomo. Você domina o francês com sutileza. Próximo passo: registros literários, expressões idiomáticas e refinamento estilístico.",
    en: "Proficient. You master French with subtlety. Next step: literary registers, idioms and stylistic refinement.",
    fr: "Autonome. Vous maîtrisez le français avec nuance. Étape suivante : registres littéraires, idiomes et finesse stylistique.",
  },
};
